export default __webpack_public_path__ + "static/media/transfiguration.c16f3282.jpg";